module.exports = __webpack_public_path__ + "static/media/students.08fdca6a.jpg";